import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLeftPanelMode, setSelectedModuleForSettings, PANEL_MODES } from '../editCourseState';

/**
 * Selectors
 */
const getEditCourse = (state) =>
  state.editCourse || {
    leftPanelMode: PANEL_MODES.TOC,
    selectedModuleForSettings: null,
  };

export const useLeftPanelMode = () => useSelector((state) => getEditCourse(state).leftPanelMode);
export const useSelectedModuleForSettings = () => useSelector((state) => getEditCourse(state).selectedModuleForSettings);

/**
 * Actions
 */
export const useSetLeftPanelMode = () => {
  const dispatch = useDispatch();
  return useCallback((mode) => dispatch(setLeftPanelMode(mode)), [dispatch]);
};

export const useToggleLeftPanelMode = () => {
  const dispatch = useDispatch();
  return useCallback(() => dispatch(setLeftPanelMode()), [dispatch]);
};

export const useSetSelectedModuleForSettings = () => {
  const dispatch = useDispatch();
  return useCallback((module) => dispatch(setSelectedModuleForSettings(module)), [dispatch]);
};
